import { useState, useEffect } from "react";

export default function Bathroom({ defaultValue, errors }) {
  const [value, setValue] = useState(
    defaultValue !== undefined && defaultValue !== null
      ? parseInt(defaultValue)
      : "",
  );
  console.log("Bathroom defaultValue:", parseInt(defaultValue));
  console.log("Bathroom defaultValue11111111:", parseInt("3.0"));
  const [isSmall] = useState(window.innerWidth <= 1500);
  const [isSmall1] = useState(window.innerWidth <= 850);

  useEffect(() => {
    if (defaultValue !== undefined && defaultValue !== null) {
      setValue(parseInt(defaultValue));
    }
  }, [defaultValue]);

  return (
    <div className={`bathroom ${errors?.bathroom ? "error" : ""}`}>
      <h5>{isSmall1 ? "ՍԱՆ." : isSmall ? "ՍԱՆՀԱՆԳ" : "ՍԱՆՀԱՆԳՈՒՅՑ"}</h5>

      <div className="with">
        {["1", "2", "3", "4", "5", "6", "7", "8", "9", "10"].map((v, i) => (
          <div key={i}>
            <input
              type="radio"
              name="bathroom"
              id={`B${i}`}
              value={parseInt(v)}
              checked={value === parseInt(v)}
              onChange={(e) => setValue(parseInt(e.target.value))}
            />
            <label htmlFor={`B${i}`}>{v}</label>
          </div>
        ))}
      </div>
    </div>
  );
}
